import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  loading: false,
  error: null,
  transferInfo: { loading: false, error: null, data: null },
}

const providerTransferSlice = createSlice({
  name: "providerTransfer",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setTransferInfo(state, action) {
      state.transferInfo = {
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.loading = false
      state.error = null
      state.transferInfo = { loading: false, error: null, data: null }
    },
  },
})

export const providerTransferAction = providerTransferSlice.actions

export default providerTransferSlice
